var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { moodboardAddLookButtonStyleChange, moodboardAddLookButtonStyleRollBack } from './viewer/addLookToMoodboardButton';
import * as tts from '@js/common/tts';
import { click } from '@js/common/tts';
import { createOrShowMoodboardPaywall, registerMoodboardPaywallClickEventListener } from "@js/common/moodboardPaywall";
import * as $ from 'jquery';
import { Router } from '@js/common/router';
import './viewer/share';
import { LoginStoreInstance } from "@ts/look/service_instance/LoginStoreInstance";
import { fetchApi, getLang } from "@js/common/helpers";
import { HttpMethods } from "tagwalk-api-client/assets/js/common/enums";
import { bindLookImageSearchButtons, LOOK_IMAGE_SEARCH_FOUND_EVENT, } from "@ts/homepage/search/component/imageSearch/lookImageSearch";
var moodboardModule;
if (document.querySelector('.moodboards-container') !== null) {
    moodboardModule = require('@js/moodboard/add');
}
document.addEventListener('login:true', function (event) {
    LoginStoreInstance.setDetail(event.detail);
});
var viewer = $('#viewer');
var prevBtn = $('#carousel .viewer-previous');
var nextBtn = $('#carousel .viewer-next');
var lang = getLang();
var lastPage = 1;
var selector = $('main');
var routeName = selector.attr('data-route');
var body = $('body');
var collectionItems = sessionStorage.getItem('collectionItems');
var memberJobs = $('.carousel-members').length > 0 ? JSON.parse($('.carousel-members').attr('data-jobs')) : [];
var spinner = $('<i class="fas fa-spinner fa-spin carousel-photo-zoom-loader"></i>');
var currentItem;
var photoList = [];
var photoListSlugs = [];
var ajaxInitRelated;
var ajaxInitPrContact;
var routeMore = null;
var searchQuery = {};
;
var currentDesignerIsClient = false;
var currentDesignerOnlineShop = null;
var viewerListenersBound = false;
function lookToViewerFormat(look, params) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        'slug': look.slug,
        'type': look.type,
        'img': look.picture_custom_urls.img,
        'img-zoom': look.picture_custom_urls.img_zoom,
        'look': look.look,
        'city-slug': (_a = look.city) === null || _a === void 0 ? void 0 : _a.slug,
        'city-name': (_b = look.city) === null || _b === void 0 ? void 0 : _b.name,
        'season-slug': (_c = look.season) === null || _c === void 0 ? void 0 : _c.slug,
        'season-name': (_d = look.season) === null || _d === void 0 ? void 0 : _d.name,
        'season-shortname': (_e = look.season) === null || _e === void 0 ? void 0 : _e.shortname,
        'designer-slug': (_f = look.designer) === null || _f === void 0 ? void 0 : _f.slug,
        'designer-name': (_g = look.designer) === null || _g === void 0 ? void 0 : _g.name,
        'designer-details': ((_h = look.designer) === null || _h === void 0 ? void 0 : _h.details) != null ? '1' : '',
        'courtesy': ((_j = look.files[0]) === null || _j === void 0 ? void 0 : _j.courtesy) ? look.files[0].courtesy : '',
        'individuals': look.individuals,
        'affiliations': look.affiliations,
        'members': look.members,
        'badge': (typeof look.watermark === 'string' && look.watermark.length > 0) ? look.watermark : null,
        'user': params.connected ? 'true' : 'false',
        'page': typeof look.page === 'number' ? look.page : 1,
        'online-shop': look.online_shop ? look.online_shop : '',
    };
}
export function closeViewer() {
    if (!viewer.hasClass('show')) {
        return;
    }
    viewer.addClass('viewer-hiding');
    window.setTimeout(function () {
        viewer.removeClass('viewer-hiding');
        viewer.modal('hide');
    }, 200);
}
viewer.on('click', '#close-modal', closeViewer);
viewer.on(LOOK_IMAGE_SEARCH_FOUND_EVENT, closeViewer);
export function initViewer(params) {
    var _a, _b, _c;
    searchQuery = params.query;
    if (params.routeMore) {
        routeMore = params.routeMore;
    }
    if (typeof params.lastPage === "number") {
        lastPage = params.lastPage;
    }
    currentDesignerIsClient = ((_a = params.designer) === null || _a === void 0 ? void 0 : _a.isClient) === true;
    currentDesignerOnlineShop = (_c = (_b = params.designer) === null || _b === void 0 ? void 0 : _b.onlineShop) !== null && _c !== void 0 ? _c : null;
    viewer.find('.carousel-details-shop-look, .carousel-details-contact')
        .toggleClass('d-none', !currentDesignerIsClient);
    viewer.find('.carousel-details-shop')
        .toggleClass('d-none', !currentDesignerIsClient || currentDesignerOnlineShop === null);
    viewer.find('.carousel-designer-shop-link').attr('href', currentDesignerOnlineShop !== null && currentDesignerOnlineShop !== void 0 ? currentDesignerOnlineShop : '#');
    bootstrapViewer(params);
    bindLookImageSearchButtons();
    params.bus.on('list', function (items) {
        photoList = items
            .filter(function (p) { return p !== null; })
            .map(function (item) {
            var data = lookToViewerFormat(item, params);
            return camelCasedDataToSpinalCase(data);
        });
        photoListSlugs = photoList.map(function (p) { return p.slug; });
    });
}
var detectAdblock = function () {
    if ($('#advertisement').css('display') === 'none') {
        $('.notice-unblock').show();
    }
};
function bootstrapViewer(params) {
    return __awaiter(this, void 0, void 0, function () {
        function onConnected() {
            var _this = this;
            addToMoodboardButton.addEventListener('click', function () { return __awaiter(_this, void 0, void 0, function () {
                var paywall;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, createOrShowMoodboardPaywall()];
                        case 1:
                            paywall = _a.sent();
                            if (paywall) {
                                return [2];
                            }
                            wireAddToMoodboardButton(addToMoodboardButton, LoginStoreInstance.detail);
                            return [2];
                    }
                });
            }); });
        }
        var addToMoodboardButton, i;
        return __generator(this, function (_a) {
            addToMoodboardButton = document.querySelector('.add-to-moodboard-button');
            if (addToMoodboardButton === null) {
                return [2];
            }
            if (localStorage.getItem('auth') !== 'logged') {
                addToMoodboardButton.classList.add('d-none');
            }
            resetAddToMoodboardButtonStyle();
            if (viewerListenersBound) {
                return [2];
            }
            viewerListenersBound = true;
            if (params.connected) {
                onConnected();
            }
            else {
                document.addEventListener('look:login:true', function () {
                    onConnected();
                });
            }
            registerMoodboardPaywallClickEventListener();
            redirectIfUserNotLogged(addToMoodboardButton);
            if ($(collectionItems) !== undefined && $(collectionItems) !== null) {
                for (i = 0; i < $(collectionItems).length; i++) {
                    if ($(collectionItems).eq(i).hasClass('carousel-collection-item')) {
                        $('.carousel-collection-list').append($(collectionItems).eq(i));
                    }
                }
                $('.carousel-details-collection').css('display', 'block');
            }
            $(prevBtn).on('click', function (e) {
                e.preventDefault();
                prevPhoto();
            });
            $(nextBtn).on('click', function (e) {
                e.preventDefault();
                nextPhoto();
            });
            $(document).on('keyup', function (e) {
                if (viewer.hasClass('active')) {
                    switch (e.key) {
                        case 'ArrowLeft':
                            prevPhoto();
                            break;
                        case 'ArrowRight':
                            nextPhoto();
                            break;
                    }
                }
            });
            viewer.on('hidden.bs.modal', function () {
                if ($(this).hasClass('zoom')) {
                    return;
                }
                reset();
            });
            viewer.find('.carousel-item-link img').on('load', function () {
                var ratio = this.width / this.height;
                ratio > 1 ? viewer.addClass('landscape') : viewer.removeClass('landscape');
            });
            detectAdblock();
            body
                .on('click', '.photo-list-item > a', open)
                .on('click', '.carousel-item-link', zoom)
                .on('click', '.carousel-designer-shop-link', saveClickAnalytic)
                .on('click', '.carousel-look-shop-link', saveClickAnalytic)
                .on('keydown', function (e) {
                if (e.key === 'Escape' && viewer.hasClass('zoom')) {
                    viewer
                        .modal({
                        backdrop: 'static',
                        keyboard: false
                    })
                        .removeClass('zoom')
                        .addClass('active');
                    $('.carousel-photo-zoom').remove();
                }
            });
            return [2];
        });
    });
}
var wireAddToMoodboardButton = function (button, userInfo) {
    if (button.classList.contains('add-to-moodboard-button-added')
        || button.classList.contains('add-to-moodboard-button-clicked')
        || !moodboardModule) {
        return;
    }
    moodboardAddLookButtonStyleChange();
    if (userInfo === null || (userInfo['email'].length !== 0 && userInfo['job_title'] != null)) {
        moodboardModule.initAddToMoodboardModal(currentItem);
        return;
    }
    moodboardModule.initNeedSubscription(currentItem);
};
var resetAddToMoodboardButtonStyle = function () {
    document.addEventListener('click', function (e) {
        var viewer = document.querySelector('#viewer');
        var arrowLeft = document.querySelector('.viewer-previous');
        var arrowRight = document.querySelector('.viewer-next');
        if ((viewer && !viewer.contains(e.target)) ||
            (arrowLeft && arrowLeft.contains(e.target)) ||
            (arrowRight && arrowRight.contains(e.target))) {
            moodboardAddLookButtonStyleRollBack();
        }
    });
    document.addEventListener('keydown', function (e) {
        var isArrowLeft = e.key === 'ArrowLeft';
        var isArrowRight = e.key === 'ArrowRight';
        if (isArrowLeft || isArrowRight) {
            moodboardAddLookButtonStyleRollBack();
        }
    });
};
var redirectIfUserNotLogged = function (addToMoodboardButton) {
    var loginStatus = localStorage.getItem('auth');
    if (loginStatus === 'anonymous') {
        addToMoodboardButton.addEventListener('click', function () {
            window.location.href = Router.generate('auth_index.' + lang);
        });
    }
};
var open = function (event) {
    var item = event.target.closest('.photo-list-item');
    if ($(item).hasClass('item-not-found')) {
        return;
    }
    event.preventDefault();
    viewer.addClass('active');
    viewer.modal('show');
    currentItem = photoList[findBy('slug', $(event.currentTarget).parent().attr('data-slug'))];
    initCarousel();
    updateBtn();
};
var updateSessionStorage = function () {
    sessionStorage.setItem('query', JSON.stringify({
        'type': currentItem['type'],
        'designer': currentItem['designer-slug'],
        'season': currentItem['season-slug']
    }));
};
var hasSameDesignerSeasonType = function () {
    var result = JSON.parse(sessionStorage.getItem('query'));
    if (result === null) {
        return false;
    }
    return result['type'] === currentItem['type']
        && result['designer'] === currentItem['designer-slug']
        && result['season'] === currentItem['season-slug'];
};
var zoom = function (event) {
    viewer.removeClass('active').addClass('zoom');
    body.prepend(spinner);
    var close = $('<div class="carousel-photo-zoom-btn"/>')
        .append('<i class="carousel-photo-zoom-close fal fa-times fa-3x"/>');
    var div = $('<div class="carousel-photo-zoom"/>')
        .append($('<img alt="" src="' + currentItem['img-zoom'] + '"/>'))
        .append(close);
    body.prepend(div);
    div.find('img').on('load', function () {
        $('.carousel-photo-zoom-loader').remove();
    });
    $('.carousel-photo-zoom, .carousel-photo-zoom-btn').on('click', function () {
        viewer.addClass('active').removeClass('zoom');
        $(this).closest('.carousel-photo-zoom').remove();
    });
    sendTtsEvent('photo_zoom');
    event.preventDefault();
};
var prevPhoto = function () {
    if (prevBtn.hasClass('disabled')) {
        return;
    }
    if (getCurrentItemPosition() === 0) {
        if (routeName === 'collection_show') {
            currentItem = photoList[photoList.length - 1];
            initCarousel();
            return;
        }
        else {
            getDataPage('prev');
            if (currentItem['page'] !== 1) {
                prevBtn.addClass('loading');
            }
        }
        return;
    }
    currentItem = photoList[getCurrentItemPosition() - 1];
    if (ajaxInitRelated && hasSameDesignerSeasonType() === false) {
        ajaxInitRelated.abort();
    }
    if (ajaxInitPrContact && sessionStorage.getItem('designer-slug') !== currentItem['designer-slug']) {
        ajaxInitPrContact.abort();
    }
    initCarousel();
    updateBtn();
};
var nextPhoto = function () {
    if (nextBtn.hasClass('disabled')) {
        return;
    }
    if (getCurrentItemPosition() === photoList.length - 1) {
        if (routeName === 'collection_show') {
            currentItem = photoList[0];
            initCarousel();
            return;
        }
        getDataPage('next');
        nextBtn.addClass('loading');
        return;
    }
    currentItem = photoList[getCurrentItemPosition() + 1];
    if (ajaxInitRelated && hasSameDesignerSeasonType() === false) {
        ajaxInitRelated.abort();
    }
    if (ajaxInitPrContact && sessionStorage.getItem('designer-slug') !== currentItem['designer-slug']) {
        ajaxInitPrContact.abort();
    }
    initCarousel();
    updateBtn();
};
var initCarousel = function () {
    reset();
    initCarouselContent();
    sendTtsEvent('photo_view');
};
var getDataPage = function (direction) {
    var route = routeMore;
    if (!route) {
        return;
    }
    if ((currentItem['page'] === lastPage && getCurrentItemPosition() === photoList.length - 1)
        || (currentItem['page'] === 1 && getCurrentItemPosition() === 0)
        || nextBtn.hasClass('loading')
        || prevBtn.hasClass('loading')) {
        return;
    }
    var query = __assign({}, searchQuery);
    switch (direction) {
        case 'next':
            var pageNext = parseInt(currentItem['page']) < lastPage ? parseInt(currentItem['page']) + 1 : currentItem['page'];
            query['page'] = pageNext;
            break;
        case 'prev':
            var pagePrev = parseInt(currentItem['page']) > 0 ? parseInt(currentItem['page']) - 1 : currentItem['page'];
            query['page'] = pagePrev;
            break;
    }
    fetchApi(route, HttpMethods.get, query).then(function (response) {
        return response.json();
    }).then(function (data) {
        if (direction === 'next' && data.length === 0) {
            lastPage = parseInt(currentItem['page']);
            nextBtn.removeClass('loading');
            updateBtn();
            return;
        }
        fillPhotoList(data, direction);
        currentItem = direction === 'next' ? photoList[getCurrentItemPosition() + 1] : photoList[getCurrentItemPosition() - 1];
        nextBtn.removeClass('loading');
        prevBtn.removeClass('loading');
        initCarousel();
    });
};
function fillPhotoList(data, direction) {
    switch (direction) {
        case 'next':
            for (var i = 0; i < data.length; i++) {
                photoList.push(camelCasedDataToSpinalCase(data[i]));
            }
            break;
        case 'prev':
            for (var i = data.length; i--;) {
                if (data[i] !== undefined) {
                    photoList.unshift(camelCasedDataToSpinalCase(data[i]));
                }
            }
            break;
    }
    photoListSlugs = photoList.map(function (p) { return p.slug; });
}
var sendTtsEvent = function (event) {
    if (currentItem['type'] === 'street') {
        tts.streetstyle(currentItem['slug'], event);
    }
    else {
        tts.media(currentItem['slug'], event);
    }
};
var reset = function () {
    viewer.find('.carousel-item-link img').attr('src', '/images/loader.gif');
    if (hasSameDesignerSeasonType() === false) {
        $('.carousel-collection-item').remove();
        $('.carousel-details-collection').hide();
    }
    $('.carousel-shop-item').remove();
    $('.carousel-individuals-item').remove();
    $('.carousel-designers-item').remove();
    $('.carousel-member-item').remove();
    $('.carousel-details-footer-container').hide();
    $('.carousel-details-individuals').hide();
    $('.carousel-details-designers').hide();
    $('.carousel-item-badge').hide();
    $('.carousel-members').hide();
};
var initCarouselContent = function () {
    var badge;
    var viewUrl;
    var text = currentItem['type'] !== undefined && currentItem['type'] === 'street' ?
        currentItem['season-name'] + " " + currentItem['city-name'] :
        currentItem['designer-name'] + " " + currentItem['season-name'];
    if (currentItem['look']) {
        text += " Look " + currentItem['look'];
    }
    if (currentItem['type'] === 'street') {
        viewer.find('.carousel-details-header').hide();
        viewer.find('.viewer-header').hide();
        viewer.find('.carousel-models').hide();
        viewer.find('.carousel-models-agencies').hide();
        viewer.find('.carousel-people').show();
        viewer.find('.carousel-details-header').css('padding-top', '15px');
        viewer.find('.carousel-details-location').show()
            .find('.carousel-details-location-value').html(currentItem['city-name'])
            .attr('href', Router.generate('streetstyle_search.' + lang, { 'city': currentItem['city-slug'] }));
        initDesigners();
        viewUrl = Router.generate('streetstyle_show.' + lang, { 'slug': currentItem['slug'] }, true);
    }
    else {
        viewer.find('.viewer-header').show();
        viewer.find('.modal-photo-designer').html(currentItem['designer-name']);
        viewer.find('.modal-photo-season').html(currentItem['season-name']);
        viewer.find('.modal-photo-look').html(currentItem['look']);
        viewer.find('.carousel-models').show();
        viewer.find('.carousel-people').hide();
        viewer.find('.carousel-details-location').hide();
        viewUrl = Router.generate('look_show.' + lang, { 'slug': currentItem['slug'] }, true);
        viewer.find('.image-search-look-button').attr('data-slug', currentItem['slug']);
        badge = currentItem['badge'];
        if (currentItem['online-shop'] && currentItem['online-shop'].trim() !== '') {
            viewer.find('.carousel-look-shop-link').attr('href', currentItem['online-shop']);
            viewer.find('.carousel-details-shop-look').show();
            viewer.find('.carousel-details-shop').hide();
        }
        else {
            viewer.find('.carousel-details-shop-look').hide();
            viewer.find('.carousel-details-shop').show();
        }
        if (badge) {
            badge = badge.split('\n').join('<br />');
            viewer.find('.carousel-item-badge').show().html(badge);
        }
    }
    viewer.find('.carousel-item-link')
        .attr('href', currentItem['img-zoom'])
        .find('img').attr('src', currentItem['img']);
    viewer.find('.carousel-details-courtesy').html(currentItem['courtesy']);
    viewer.find('.share-icon').attr('data-url', viewUrl);
    viewer.find('.share-icon').attr('data-img', currentItem['img']);
    viewer.find('.share-icon').attr('data-text', text);
    initShop();
    initIndividuals();
    initPrContact();
    initMembers();
    if (currentItem['type'] !== 'street'
        && currentItem['designer-slug'] !== undefined
        && currentItem['season-slug'] !== undefined) {
        initRelatedPhotos();
    }
};
var initShop = function () {
    if (isEmptyInCurrent('affiliations') === false) {
        var container_1 = $('.carousel-shop-list-items');
        var affiliations = currentItem['affiliations'];
        var hoverText_1 = $('.carousel-shop-item-text').html();
        var prototypeItem_1 = $('.carousel-shop-prototype');
        affiliations.forEach(function (affiliation) {
            var itemBlock = $(prototypeItem_1).clone().show().attr('class', 'carousel-shop-item');
            itemBlock
                .find('.carousel-designer-shop-link')
                .attr('href', affiliation['link'])
                .attr('target', affiliation['link_target'])
                .find('.carousel-shop-item-text').html(affiliation.name);
            itemBlock.on('mouseenter', function () {
                $(this).find('.carousel-shop-item-text').html(hoverText_1);
            });
            itemBlock.on('mouseleave', function () {
                $(this).find('.carousel-shop-item-text').html(affiliation.name);
            });
            container_1.append(itemBlock);
        });
        $('.carousel-details-shop').show();
    }
};
var initIndividuals = function () {
    if (isEmptyInCurrent('individuals') === false) {
        var individuals = currentItem['individuals'];
        var hasAgencies = individuals.map(function (individual) {
            return individual['agencies'] !== undefined && individual['agencies'] !== null;
        }).includes(true);
        if (hasAgencies === false) {
            viewer.find('.carousel-models-agencies').hide();
            viewer.find('.carousel-models').show();
        }
        else {
            viewer.find('.carousel-models-agencies').show();
            viewer.find('.carousel-models').hide();
        }
        viewer.find('.carousel-details-footer-container').show();
        var prototypeItem_2 = currentItem['type'] === 'street' ?
            $('.carousel-people .carousel-individuals-prototype') :
            (hasAgencies ? $('.carousel-models-agencies .carousel-individuals-prototype') : $('.carousel-models .carousel-individuals-prototype'));
        var container_2 = prototypeItem_2.closest('.carousel-individuals-list');
        individuals.forEach(function (individual) {
            var itemBlock = $(prototypeItem_2).clone();
            var individualLink = Router.generate('model_show.' + lang, {
                'slug': individual.slug
            });
            itemBlock.attr('class', 'carousel-individuals-item');
            itemBlock.show();
            $(itemBlock).find('.carousel-individuals-item-link').attr('href', individualLink);
            $(itemBlock).find('.carousel-individuals-item-name').html(individual.name);
            if (individual['agencies'] !== undefined && individual['agencies'] !== null) {
                individual['agencies'].forEach(function (agency, key, arr) {
                    var agencyLink = Router.generate('agency_show.' + lang, { 'slug': agency.slug });
                    var agencyLinkBlock = $("<a href='" + agencyLink + "'>" + agency.name + "</a>");
                    $(itemBlock).find('.carousel-individuals-item-agencies').append(agencyLinkBlock);
                    if (key !== arr.length - 1) {
                        $(itemBlock).find('.carousel-individuals-item-agencies').append(', ');
                    }
                });
            }
            container_2.append(itemBlock);
        });
        $('.carousel-details-individuals').show();
    }
};
var initRelatedPhotos = function () {
    var query = {
        'type': currentItem['type'],
        'designer': currentItem['designer-slug'],
        'season': currentItem['season-slug'],
        'city': currentItem['city-slug']
    };
    if (hasSameDesignerSeasonType() === false) {
        var collectionBlock = $('.carousel-details-collection');
        var collectionList_1 = $('.carousel-collection-list');
        var prototypeItem_3 = $('.carousel-collection-prototype');
        var collectionLink = Router.generate('look_search.' + lang, query);
        if (!sessionStorage.getItem('query')) {
            sessionStorage.setItem('query', JSON.stringify(query));
        }
        updateSessionStorage();
        viewer.find('.carousel-details-collection').css('display', 'block');
        collectionBlock.attr('href', collectionLink);
        ajaxInitRelated = $.ajax({
            url: Router.generate('look_related'),
            method: 'GET',
            global: false,
            data: query,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        }).done(function (data) {
            $.each(data, function (i, item) {
                var itemBlock = prototypeItem_3.clone();
                itemBlock.attr('class', 'carousel-collection-item');
                itemBlock.show();
                itemBlock.find('img').addClass('carousel-collection-item-img').attr('src', item.files[0]['path_thumbnail']);
                collectionList_1.append(itemBlock);
            });
            sessionStorage.setItem('collectionItems', $('.carousel-collection-list').html());
        });
    }
    else {
        var collectionLink = Router.generate('look_search.' + lang, query);
        $('.carousel-details-collection').attr('href', collectionLink);
    }
};
var initDesigners = function () {
    if (isEmptyInCurrent('designers') === false) {
        var designers = currentItem['designers'];
        var prototypeItem_4 = $('.carousel-designers-prototype');
        viewer.find('.carousel-details-footer-container').show().find('.carousel-details-designers').show();
        designers.forEach(function (designer) {
            var itemBlock = prototypeItem_4
                .clone()
                .attr('class', 'carousel-designers-item')
                .show();
            itemBlock
                .find('.carousel-designers-link')
                .attr('href', Router.generate('streetstyle_search.' + lang, { 'designers': designer.slug }))
                .html(designer.name);
            $('.carousel-details-designers').append(itemBlock);
        });
    }
};
var initMembers = function () {
    if (isEmptyInCurrent('members') === false) {
        var team_1 = memberJobs.reduce(function (o, k) {
            var _a;
            return (__assign(__assign({}, o), (_a = {}, _a[k] = [], _a)));
        }, {});
        var members = currentItem['members'];
        var prototype = $('.carousel-members-prototype');
        var slugs_1 = [];
        viewer
            .find('.carousel-details-footer-container').show()
            .find('.carousel-members').show();
        members.forEach(function (member) {
            if (memberJobs.includes(member.job) && !team_1[member.job].includes(member.name)) {
                team_1[member.job].push(member.name);
                slugs_1[member.name] = member.slug;
            }
        });
        for (var job in team_1) {
            if (team_1.hasOwnProperty(job) && team_1[job].length > 0) {
                var reformatedJob = job.replace(' ', '_');
                var jobValue = Translator.transChoice("member_jobs." + reformatedJob, team_1[job].length);
                var links = team_1[job].map(function (member) {
                    var query = {
                        'slug': slugs_1[member]
                    };
                    return "<a href=\"" + Router.generate('member_show.' + lang, query) + "\"> " + member + " </a>";
                });
                var names = links.join(', ');
                var item = prototype
                    .clone()
                    .attr('class', 'carousel-member-item')
                    .show();
                item.find('.carousel-member-value').html("<span class=\"carousel-member-job\">" + jobValue + "</span>: <span class=\"carousel-member-name\">" + names + "</span>");
                $('.carousel-members').append(item);
            }
        }
    }
};
var initPrContact = function () {
    var prContact = $('.carousel-details-prcontact');
    if (currentItem['type'] === 'street') {
        prContact.hide();
        return;
    }
    if (sessionStorage.getItem('designer-slug') === null
        || sessionStorage['designer-slug'] !== currentItem['designer-slug']) {
        prContact.hide();
        var query_1 = {
            'slug': currentItem['designer-slug']
        };
        ajaxInitPrContact = $.ajax({
            url: Router.generate('designer_ajax_get.' + lang, query_1),
            method: 'GET',
            global: false
        }).done(function (data) {
            sessionStorage.setItem('designer-slug', currentItem['designer-slug']);
            sessionStorage.setItem('designer-details', data['details'] !== null);
            if (data['details'] !== null) {
                prContact.show();
                prContact.attr('href', Router.generate('designer_details.' + lang, query_1));
            }
            else {
                prContact.hide();
            }
        });
    }
    else if (sessionStorage.getItem('designer-details') === 'true' && sessionStorage['designer-slug'] === currentItem['designer-slug']) {
        prContact.show();
        prContact.attr('href', Router.generate('designer_details.' + lang, { 'slug': currentItem['designer-slug'] }));
    }
    else {
        prContact.hide();
    }
};
var getCurrentItemPosition = function () {
    return photoListSlugs.indexOf(currentItem.slug);
};
var isEmptyInCurrent = function (attr) {
    return currentItem[attr] === undefined || currentItem[attr] === null || !currentItem[attr].length;
};
var findBy = function (attr, value) {
    for (var i = 0; i < photoList.length; i++) {
        if (photoList[i][attr] === value) {
            return i;
        }
    }
    return 0;
};
var updateBtn = function () {
    if (routeName === 'collection_show') {
        return;
    }
    if (routeName === 'trends_list' && getCurrentItemPosition() === photoList.length - 1) {
        nextBtn.addClass('disabled');
    }
    else if (currentItem['page'] === lastPage && getCurrentItemPosition() === photoList.length - 1) {
        nextBtn.addClass('disabled');
    }
    else {
        nextBtn.removeClass('disabled');
    }
    if ((currentItem['page'] === 1 && getCurrentItemPosition() === 0)) {
        prevBtn.addClass('disabled');
    }
    else if (routeName === 'trends_list' && getCurrentItemPosition() === 0) {
        prevBtn.addClass('disabled');
    }
    else {
        prevBtn.removeClass('disabled');
    }
};
var camelCasedDataToSpinalCase = function (data) {
    var tmp = {};
    for (var _i = 0, _a = Object.entries(data); _i < _a.length; _i++) {
        var _b = _a[_i], k = _b[0], v = _b[1];
        tmp[toSpinalCase(k)] = v;
    }
    return tmp;
};
var toSpinalCase = function (str) {
    return str.split('').map(function (c) {
        if (c === c.toUpperCase() && c !== '-') {
            return '-' + c.toLowerCase();
        }
        else {
            return c;
        }
    })
        .join('');
};
var saveClickAnalytic = function (event) {
    var element = event.target;
    element = element.closest('.carousel-designer-shop-link, .carousel-look-shop-link');
    if (!element) {
        return;
    }
    var slug = currentItem['slug'];
    var params = {
        'media_slug': slug,
        'route': routeName
    };
    click(element.getAttribute('href'), params);
};
